module.exports = __webpack_public_path__ + "static/media/Logos uniservice-05.ffe0e2f2.svg";